import posthog from "posthog-js";

// VITE_POSTHOG_HOST points at our same-origin reverse proxy
// (https://v.buscablindados.com) so adblockers can't pattern-match
// *.posthog.com on requests. Falls back to the PostHog edge only for local
// dev without the env var set — and ad-blocked anyway.
const key = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const host = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? "https://us.i.posthog.com";

// posthog.init() makes network calls — not allowed at global scope in CF Workers.
if (key && typeof document !== "undefined") {
  posthog.init(key, {
    api_host: host,
    // `defaults` pins behavior to a date so future posthog-js releases
    // don't silently flip flags on us. 2026-01-30 matches what PostHog's
    // current install snippet recommends.
    defaults: "2026-01-30",
    person_profiles: "identified_only",
    capture_pageview: false,
    capture_pageleave: true,
    autocapture: true,
    capture_exceptions: true,
    disable_surveys: true,
    disable_session_recording: false,
  });
}

export { posthog };
